/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc pc端底部旗舰店列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ShopsAllParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: ShopsAllParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.TheaterShopsDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shops/all`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
